<template lang="html">
  <div>
    <championship-selector></championship-selector>
    <h2 class="tituloHead">
      {{ current_championship.name }}
    </h2>
    <menu-home v-if="current_championship">
      <div slot="title">Preferencias</div>
      <div slot="buttons" aria-label="Justified button group" role="group" class="btn-group btn-group-justified">
        <menu-button menu-url="/configuration/dates/" glyph-icon="glyphicon-calendar">Fechas</menu-button>
        <menu-button menu-url="/configuration/categories/" glyph-icon="glyphicon-equalizer">Categorías</menu-button>
        <menu-button menu-url="/configuration/courses/" glyph-icon="glyphicon-blackboard">Canchas</menu-button>
        <menu-button menu-url="/configuration/awards/" glyph-icon="glyphicon-glass">Copas</menu-button>
        <menu-button menu-url="/configuration/players/" glyph-icon="glyphicon-user">Inscritos</menu-button>
        <menu-button menu-url="/configuration/teams/" glyph-icon="glyphicon-cog">Equipos</menu-button>
      </div>
    </menu-home>
    <router-view></router-view>
  </div>
</template>

<script>
import MenuButton from '../components/MenuButton'
import MenuHome from '../components/MenuHome'
import ChampionshipSelector from '../components/configuration/ChampionshipSelector'
import {getConfigChampionship} from '../vuex/getters'
export default {
  vuex: {
    getters: {
      current_championship: getConfigChampionship
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  ready() {},
  attached() {},
  methods: {},
  components: { MenuButton, MenuHome, ChampionshipSelector }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** Configuration.vue?53ba51b4
 **/